import React, { Suspense, useState, useEffect } from "react";
import Pagination from "components/Common/newPagination";
import systemListingService from "./SystemListingServices";
import SubproviderUpsert from "./upsert/SubproviderUpsert";
import DeleteDialogueBox from "components/Common/deleteDialogue";
import { CommonUtilities } from "commonUtils";

export default function SubProvider(param: any) {

  let [searchFor, setsearchFor] = useState("");
  let [showBulkDrawer, setShowBulkDrawer] = useState(false);
  let [editingOn, setEditingOn] = useState<boolean>(false);
  let [confirmationFilter, setConfirmationFilter] = useState<"confirmed" | "notConfirmed">("confirmed");
  let [accountSubproviderList, SetaccountSubproviderListing] = useState<any>([]);
  let [accountSubproviderCount, SetaccountSubproviderCount] = useState(0);

  useEffect(() => {

    if (param.activeTab === "Accounts/Sub Provider") {
      accountSubproviderSelect()
    }
  }, [param])

  let [openUpsertUX, setOpenUpsertUX] = useState(false);
  let [editDataDawer, seteditDataDawer] = useState<any>([]);

  const openAddDrawer = (e: any) => {
    editDataDawer = e
    seteditDataDawer(editDataDawer)
    openUpsertUX = true
    setOpenUpsertUX(openUpsertUX)
  };

  const closeUpsertUX = () => {
    setOpenUpsertUX(!openUpsertUX)
  }

  var payLoad = { pageNumber: 1, pageSize: 10, SearchFor: '' }

  const onPageChange = (e: any) => {
    console.log(e)
    payLoad.pageNumber = e.pageNumber;
    payLoad.pageSize = e.pageSize;
    accountSubproviderSelect();
  };

  const accountSubproviderSelect = () => {

    payLoad.SearchFor = searchFor
    systemListingService.accountSubproviderList(payLoad).then((res: any) => {

      accountSubproviderList = res;
      SetaccountSubproviderListing(accountSubproviderList)

      accountSubproviderCount = res[0] && res[0].totalRows ? res[0].totalRows : 0;
      SetaccountSubproviderCount(accountSubproviderCount)
    })

  };

  let [deleteData, setDeleteData] = useState<any>([]);
  let [deleteStatus, setDeleteStatus] = useState(false);
  const deleteSelection = (e: any) => {
    console.log(e)
    deleteData = e
    setDeleteData(deleteData)

    deleteStatus = true;
    setDeleteStatus(deleteStatus)
  }

  const deleteConfirmation = (e: any) => {
    console.log(e)

    //e==1 YES
    if (e == 1) {
      systemFormatsList.deleteAccountCode(deleteData).then((respond: any) => {
        CommonUtilities.showToastDawer('Accounts/Sub Provider delete Successfull', 'Success')
      })
    }
    //e==2 NO
    deleteStatus = false;
    setDeleteStatus(deleteStatus)
  }
  const accountSubproviderExport = function (type: any) {
    systemListingService.accountSubproviderExport({ export: 1 })
  };

  const slider_handler = (e: any, selectData: any) => {

    if (e.target.type == "checkbox") {

      selectData[e?.target?.name] = Number(selectData[e?.target?.name]) == 1 ? 0 : 1

      systemListingService.saveAccountSubprovider(selectData).then((repond: any) => {
        accountSubproviderSelect();
      })
    }
  }

  return (
    <>
      <div className="content-card ws-12">

        {/* Header */}
        <div className=" ws-12">
          <div className="card-title">Accounts/Sub Providers</div>

          <div className="ws-12 mb">
            <span className="pt mt pull-left">{accountSubproviderCount} record(s) found  </span>
            <button className="icon-btn info pull-right" id="editModeBtn" type="button" onClick={() => setEditingOn((prev) => !prev)}> {editingOn ? "Edit Mode: On" : "Edit Mode: Off"}  </button>
          </div>
        </div>

        <div className=" ws-12 pbl" >

          <div className="ws-6">
            <div className="ws-12 text-bold pbl">Filter</div>
            <input className="ws-10" placeholder="By code, description or group" value={searchFor} onChange={(e) => setsearchFor(e.target.value)} style={{ minWidth: 420 }} />
            <button className="icon-btn primary height35" type="button" onClick={accountSubproviderSelect}>Search</button>
          </div>

          <div className="ws-2 mtxl" >

            <label className="ws-12 mt">
              <input type="radio" name="confirmed" value="confirmed" checked={confirmationFilter === "confirmed"} onChange={() => setConfirmationFilter("confirmed")} />
              <span>User Confirmed</span>
            </label>

            <label className="ws-12">
              <input type="radio" name="confirmed" value="notConfirmed" checked={confirmationFilter === "notConfirmed"} onChange={() => setConfirmationFilter("notConfirmed")} />
              <span>User Not Confirmed</span>
            </label>

            <button className="bulk-btn hide" type="button" onClick={() => setShowBulkDrawer(true)}   >
              Bulk Update
            </button>
          </div>

          <div className="ws-4 mtxl">
            <button className="icon-btn primary height35 fill pull-right" type="button" disabled={!editingOn} onClick={() => openAddDrawer({})} >Add Accounts/Sub Provider </button>
            <button className="icon-btn primary height35 pull-right" onClick={accountSubproviderExport}> <i className="icon-download1"></i></button>
          </div>

        </div>

        {/* Table */}
        <div className="ws-12">

          {accountSubproviderCount > 0 && <div className="allowHscroll">
            <table className={editingOn ? "editing-on newTable" : " newTable"} >
              <thead>
                <tr>
                  <th className="forceSingleLine">Reported AccountCode </th>
                  <th className="forceSingleLine">Reported SubProvider </th>
                  <th className="forceSingleLine">Display AccountCode  </th>
                  <th className="forceSingleLine">Display SubProvider  </th>
                  <th className="forceSingleLine">Display Single AccSub </th>
                  <th className="forceSingleLine">User Confirmation</th>
                  <th > Operations</th>
                </tr>
              </thead>
              <tbody>
                {accountSubproviderList.map((row: any, index: any) => {

                  return (
                    <tr key={index}>
                      <td>{row.fsaAccountCode}</td>
                      <td>{row.fsapSubProvder}</td>
                      <td>{row.showAccountCode}</td>
                      <td> {row.showSingleAccSub}</td>
                      <td>{row.showSingleAccSub}</td>
                      <td>
                        <label className="switch" style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}} >
                          <input type="checkbox" name="userConfirmed" checked={Number(row?.userConfirmed) === 1} onChange={(e: any) => slider_handler(e, row)} />
                          {Number(row?.userConfirmed) === 1 && <span className="slider round text-left white pm pts" >Yes</span>}
                          {Number(row?.userConfirmed) === 0 && <span className="slider round text-right white pm pts sliderOff">No</span>}
                        </label>

                      </td>

                      <td>
                        <div style={{ pointerEvents: editingOn ? "auto" : "none", opacity: editingOn ? 1 : 0.6, cursor: editingOn ? "pointer" : "not-allowed" }} className="width140">
                          <button className="icon-btn edit" title="Edit" type="button" disabled={!editingOn} onClick={() => openAddDrawer(row)}><i className="icon-pencil"> </i> </button>
                          <button className="icon-btn delete" title="Delete" type="button" disabled={!editingOn} onClick={() => deleteSelection(row)}><i className="icon-trash"> </i> </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}

              </tbody>
            </table>

            {(() => {
              if (accountSubproviderCount === 0) {
                return <Pagination totalRow={accountSubproviderCount} onPageChange={onPageChange} />
              }
            })()}

          </div>}

          {accountSubproviderCount === 0 && <div className="alert alert-info ws-12 box" >No records to display</div>}

        </div>


      </div>

      {
        (() => {
          if (openUpsertUX) {
            return <SubproviderUpsert openUpsertUX={openUpsertUX} closeDrawer={closeUpsertUX} editDataDawer={editDataDawer} />
          }

          if (deleteStatus) {
            return <DeleteDialogueBox param={deleteStatus} message={"delete the selected account code " + deleteData?.fsaAccountCode} onChange={deleteConfirmation} />
          }

        })()
      }
    </>
  );
};